// LineChart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale , PointElement} from 'chart.js';
 
ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale , PointElement);

const LineChart = () => { 
  const data = {
    labels: [ 'April 2024', 'May 2024', 'Jun 2024', 'July 2024', 'Aug 2024' ,'Sep 2024' , 'Oct 2024' ,'Nov 2024' , 'Dec 2024'],  
    datasets: [
      {
        label: ' ',
        data: [0 ,-100, 100 , 0, 200 , 100, 300, 200, 400], 
        fill: false,
        borderColor: 'rgba(34, 201, 79, 1)',
        backgroundColor: 'rgba(52, 177, 227, 0.2)', 
      },
    ],
  };

   
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: '',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (context.parsed.y !== null) {
              label += `: ${context.parsed.y}`;
            }
            return label;
          },
        },
      },
    },
    maintainAspectRatio: false,  
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ width: '100%', maxWidth: '1400px', height: '310px', position: 'relative' }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
